import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    minHeight: 0,
  },
  messagesRegion: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0,
  },
  inputRegion: {
    flexShrink: 0,
    width: '100%',
    backgroundColor: theme.new.color.common.white,
    paddingTop: 10,
    paddingBottom: 10,
  },
  m1Footer: {
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    gap: 20,
    width: '100%',
    boxSizing: 'border-box',
    padding: theme.new.spacing.large,
  },
  m1SearchRegion: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.new.spacing.small,
    width: '100%',
  },
}));

export default useStyles;
